import React from 'react'
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function HomeHeritage() {
  return (
    <>
    <div className="home-heritage">
        <div className="container">
            <div className="row">  

                <div className="col-lg-6 col-md-7">
                    <div className="heritage-box wow animate__animated animate__slideInLeft" data-wow-duration="1.1s" data-wow-delay="0.2s">
                        <div></div>
                        <span>Explore</span>
                        <h4 className="heading">An Inspirational Heritage</h4>
                        <p>Lucknow Public School is built on a strong foundation of values, discipline, and excellence. It inspires students to dream big, work hard, and lead with confidence.</p>
                        <p>With a proud legacy of shaping bright futures, LPS continues to light the path for generations to come.</p>
                        <Link to={"/our-heritage"} className="arrow-butn blue-arrowbtn">Discover More <Icons name="Longarrow_right"/></Link>
                    </div> 
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
